import { CustomizationDeliveryEditScreen } from '../../../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <CustomizationDeliveryEditScreen />;
}
